import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { MaintenanceService } from '../service/maintenance.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { COMMONS_ENVIRONMENT } from '../interface/environment/commons-environment.interface';

@Injectable()
export abstract class PageMaintenance {
  private readonly env = inject(COMMONS_ENVIRONMENT);
  protected router = inject(Router);
  protected readonly maintenanceService = inject(MaintenanceService);

  public maintenanceLogoPath = signal(this.env?.maintenance?.logoPath ?? '');

  constructor() {
    this.subscribeToMaintenanceService();
    this.navigateToDefaultRoute();
  }

  private subscribeToMaintenanceService() {
    this.maintenanceService.maintenanceConfig$
      .pipe(takeUntilDestroyed())
      .subscribe({
        next: () => {
          this.navigateToDefaultRoute();
        },
      });
  }

  private navigateToDefaultRoute() {
    if (this.maintenanceService.isActive) {
      return;
    }
    this.router.navigateByUrl(this.env.app.defaultRoute).then();
  }
}
